import { format, isFuture } from 'date-fns';

const formatDate = (date: string, form = 'MMM dd, yyyy, HH:mm'): string =>
  format(new Date(date), form);

export const getAssignmentSubtitle = ({
  endDate,
  closedAt,
  startDate,
  extensionTitle,
}: {
  endDate?: string;
  startDate?: string;
  closedAt?: string;
  extensionTitle?: string;
}) => {
  if (!endDate || !startDate) return '';

  let extensionPrefix = '';
  if (extensionTitle) {
    extensionPrefix = `${extensionTitle} - `;
  }
  if (closedAt) {
    return `${extensionPrefix}Closed on: ${formatDate(closedAt)}`;
  }

  if (startDate && isFuture(new Date(startDate))) {
    return `${extensionPrefix}Opens on: ${formatDate(
      startDate
    )} - Due on: ${formatDate(endDate)}`;
  }

  return `${extensionPrefix}Due: ${formatDate(endDate)}`;
};
